import { useContext } from 'react'
import { PageContext } from 'contexts'

export default function usePage() {
  return useContext(PageContext)
}
